import React from "react"
import {UxCTA as CTA} from "@next/ux-cta"
import connect from "./connect"
import ShoppingBagNotificationMessage from "../ShoppingBagNotificationMessage"
import {Container, ActionWrapper} from "./component"

export type ShoppingBagNotificationProps = {
    text: any
    itemCount: number
    checkoutUrl: string
}

export const ShoppingBagNotification = ({text, itemCount, checkoutUrl}: ShoppingBagNotificationProps) => {
    const getItemCountText = () => {
        const template = itemCount === 1 ? text.shoppingBag.singleItemInBag : text.shoppingBag.multipleItemsInBag
        return template.replace("{count}", itemCount.toString())
    }

    return itemCount === 0 ? null : (
        <Container data-testid="header-shopping-bag-notification">
            <ShoppingBagNotificationMessage>{getItemCountText()}</ShoppingBagNotificationMessage>

            <ActionWrapper data-testid="header-shopping-bag-notification-view-edit-bag-btn">
                <CTA
                    text={text.miniShoppingBag.viewAndEditBag as string}
                    url={checkoutUrl}
                    color="secondary"
                    state="enabled"
                    variant="contained"
                    size="medium"
                />
            </ActionWrapper>
        </Container>
    )
}

export default connect(ShoppingBagNotification)
